const tableCompetitions = [
  {
    competitionId: 1,
    season: "2023",
    championship: "Départemental",
    category: "11/12 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "D",
        path: "https://tenup.fft.fr/championnat/82346138?division=116140&phase=185154&poule=426561",
        players: [
          {
            playerName: "SALGADO Rafael",
            email: "gmarechal01@gmail.com",
            tel: "06.43.84.05.43",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4546267 U",
          },
          {
            playerName: "GREHAL Leon",
            email: "maxime.grehal@gmail.com",
            tel: "06.70.53.67.90",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1022435 S",
          },
          {
            playerName: "LAY Aslan",
            email: "lay.stephane@wanadoo.fr",
            tel: "06.13.63.87.01",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1047355 D",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 2",
        group: "E",
        path: "https://tenup.fft.fr/championnat/82346138?division=116141&phase=185155&poule=426566",
        players: [
          {
            playerName: "PONCET Victor",
            email: "fd.poncet@orange.fr",
            tel: "06.72.82.36.27",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "4545533 W",
          },
          {
            playerName: "GUILLEMIN Aloïs",
            email: "guillemin.guillaume@orange.fr",
            tel: "06.59.27.42.02",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "0595594 J",
          },
          {
            playerName: "MATRAS ezequiel",
            email: "matmatras@yahoo.fr",
            tel: "06.65.81.01.36",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "9923587 G",
          },
        ],
      },
    ],
  },
  {
    competitionId: 2,
    season: "2023",
    championship: "Départemental",
    category: "15/18 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 3",
        group: "C",
        path: "https://tenup.fft.fr/championnat/82346141?division=116577&phase=185770&poule=427690",
        players: [
          {
            playerName: "DEMIRAY Kenan",
            email: "kupraa@gmail.com",
            tel: "06.69.13.07.90",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "4440129 B",
          },
          {
            playerName: "SURACE Adrien",
            email: "sandrine.surace@sfr.fr",
            tel: "06.43.70.43.56",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1634354 W",
          },
          {
            playerName: "GALLION Nicolas",
            email: "laurablue2907@hotmail.com",
            tel: "06.62.43.38.65",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "8727425 F",
          },
        ],
      },
    ],
  },
  {
    competitionId: 3,
    season: "2023",
    championship: "Départemental",
    category: "15/18 ans",
    gender: "Filles",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "1",
        path: "https://tenup.fft.fr/championnat/82346140?division=116572&phase=185763&poule=427621",
        players: [
          {
            playerName: "ALBAN Eléna",
            email: "alban.ceciliaetstephane@neuf.fr",
            tel: "06.35.25.88.90",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "6162636 S",
          },
          {
            playerName: "LAURENT Andrea",
            email: "andrealaurent202@gmail.com",
            tel: "06.66.08.01.62",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "9212356 E",
          },
          {
            playerName: "GRANGER Noémie",
            email: "vergranger@orange.fr",
            tel: "06.25.70.61.32",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4540484 H",
          },
        ],
      },
    ],
  },
  {
    competitionId: 4,
    season: "2023",
    championship: "Coupe Henry Genéty",
    category: "13/14 ans",
    gender: "Mixte",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82367960?division=119945&phase=191721&poule=438110",
        players: [
          {
            playerName: "GRANGER Noémie",
            email: "vergranger@orange.fr",
            tel: "06.25.70.61.32",
            ranking: "30/3",
            rankingDouble: "15",
            licenceNum: "4540484 H",
          },
          {
            playerName: "SALGADO Rafael",
            email: "gmarechal01@gmail.com",
            tel: "06.43.84.05.43",
            ranking: "30/3",
            rankingDouble: "15",
            licenceNum: "4546267 U",
          },
          {
            playerName: "ALBAN Quentin",
            email: "alban.ceciliaetstephane@neuf.fr",
            tel: "06.73.24.76.98",
            ranking: "40",
            rankingDouble: "18",
            licenceNum: "8022720 X",
          },
          {
            playerName: "PANIE César",
            email: "jeromepanie@gmail.com",
            tel: "06.88.32.78.49",
            ranking: "40",
            rankingDouble: "18",
            licenceNum: "4544557 K",
          },
        ],
      },
    ],
  },
  {
    competitionId: 5,
    season: "2023",
    championship: "Ligue",
    category: "Seniors",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Ligue 3",
        group: "H",
        path: "https://tenup.fft.fr/championnat/82335989?division=114404&phase=182814&poule=439245",
        players: [
          {
            playerName: "BRESSAN Loic",
            email: "loicbressan6@gmail.com",
            tel: "06.50.78.05.81",
            ranking: "15/2",
            doubleRanking: "8",
            licenceNum: "2205855 T",
          },
          {
            playerName: "SCHULLER Antoine",
            email: "antoine.schuller@yahoo.fr",
            tel: "06.10.34.28.46",
            ranking: "15/2",
            doubleRanking: "8",
            licenceNum: "6348702 M",
          },
          {
            playerName: "DU ROURE Ludovic",
            email: "ludo-71@hotmail.fr",
            tel: "06.73.04.93.20",
            ranking: "15/2",
            doubleRanking: "18",
            licenceNum: "2317909 R",
          },
          {
            playerName: "JARILLO Lonny",
            email: "lonny.jarillo@icloud.com",
            tel: "07.67.83.10.08",
            ranking: "15/2",
            doubleRanking: "8",
            licenceNum: "6423069 W",
          },
          {
            playerName: "VIDON Alexandre",
            email: "alexandre.vidon@gmail.com",
            tel: "06.60.31.14.62",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "3919020 D",
          },
          {
            playerName: "DEFALLETANS Benoit",
            email: "bendefalletans@gmail.com",
            tel: "06.11.65.97.15",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "5868577 M",
          },
          {
            playerName: "SINIBALDI Thomas",
            email: "thomasinibaldi@gmail.com",
            tel: "06.58.91.15.06",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "3025132 L",
          },
          {
            playerName: "GIRARD Clément",
            email: "clement0171@free.fr",
            tel: "06.95.29.02.14",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "0531762 B",
          },
        ],
      },
    ],
  },
  {
    competitionId: 6,
    season: "2023",
    championship: "Départemental",
    category: "Seniors",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 2,
        level: "Division 3",
        group: "E",
        path: "https://tenup.fft.fr/championnat/82370648?division=119128&phase=190362&poule=440768",
        players: [
          {
            playerName: "VIDON Alexandre",
            email: "alexandre.vidon@gmail.com",
            tel: "06.60.31.14.62",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "3919020 D",
          },
          {
            playerName: "SINIBALDI Thomas",
            email: "thomasinibaldi@gmail.com",
            tel: "06.58.91.15.06",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "3025132 L",
          },
          {
            playerName: "GIRARD Clément",
            email: "clement0171@free.fr",
            tel: "06.95.29.02.14",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "0531762 B",
          },
          {
            playerName: "DEFALLETANS Benoit",
            email: "bendefalletans@gmail.com",
            tel: "06.11.65.97.15",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "5868577 M",
          },
          {
            playerName: "PERRIN Thomas",
            email: "thomas.perrinissautier@gmail.com",
            tel: "06.37.30.60.91",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "4924761 A",
          },
          {
            playerName: "CEDDIA Michel",
            email: "ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "MARTIN Alexandre",
            email: "alex.martin71@wanadoo.fr",
            tel: "06.29.51.49.28",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "2317754 X",
          },
          {
            playerName: "PENIN Gonzague",
            email: "penin.gonzague@outlook.com",
            tel: "06.71.32.31.85",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "1047404 G",
          },
          {
            playerName: "MATRAS Mathieu",
            email: "matmatras@yahoo.fr",
            tel: "06.07.43.71.15",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7486886 U",
          },
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
        ],
      },
      {
        teamNum: 3,
        level: "Division 3",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82370648?division=119128&phase=190362&poule=440765",
        players: [
          {
            playerName: "PERRIN Thomas",
            email: "thomas.perrinissautier@gmail.com",
            tel: "06.37.30.60.91",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "4924761 A",
          },
          {
            playerName: "PENIN Gonzague",
            email: "penin.gonzague@outlook.com",
            tel: "06.71.32.31.85",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "1047404 G",
          },
          {
            playerName: "MARTIN Alexandre",
            email: "alex.martin71@wanadoo.fr",
            tel: "06.29.51.49.28",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "2317754 X",
          },
          {
            playerName: "CEDDIA Michel",
            email: "ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "MATRAS Mathieu",
            email: "matmatras@yahoo.fr",
            tel: "06.07.43.71.15",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7486886 U",
          },
          {
            playerName: "BRUNET Nicolas",
            email: "nbrunet40@neuf.fr",
            tel: "06.86.33.70.22",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1338296 U",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5564257 E",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "clairbenjamin71@gmail.com",
            tel: "06.43.93.15.99",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1990929 C",
          },
          {
            playerName: "GATINET Francois",
            email: "fxparisien71@hotmail.fr",
            tel: "06.60.85.07.50",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1071895 C",
          },
        ],
      },
      {
        teamNum: 4,
        level: "Division 4",
        group: "G",
        path: "https://tenup.fft.fr/championnat/82370648?division=119127&phase=190361&poule=440796",
        players: [
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BRUNET Nicolas",
            email: "nbrunet40@neuf.fr",
            tel: "06.86.33.70.22",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1338296 U",
          },
          {
            playerName: "MAZILLE Ludovic",
            email: "ludovic.mazille@sfr.fr",
            tel: "06.63.39.00.20",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5103391 N",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "clairbenjamin71@gmail.com",
            tel: "06.43.93.15.99",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1990929 C",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5564257 E",
          },
          {
            playerName: "GATINET Francois",
            email: "fxparisien71@hotmail.fr",
            tel: "06.60.85.07.50",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1071895 C",
          },
          {
            playerName: "MARCHAND Frédéric",
            email: "fredericmarchand01@gmail.com",
            tel: "06.42.16.05.56",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1033027 E",
          },
          {
            playerName: "LETOURNEAUX Quentin",
            email: "quentin.letourneaux@free.fr",
            tel: "07.88.19.05.42",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "4627072 A",
          },
          {
            playerName: "CATHERIN Jérémie",
            email: "jeremie.catherin@gmail.com",
            tel: "06.21.78.60.43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "8312714 H",
          },
          {
            playerName: "PETIT Hervé",
            email: "kekevalpetit@aol.com",
            tel: "06.84.70.35.01",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "0619205 Y",
          },
        ],
      },
    ],
  },
  {
    competitionId: 7,
    season: "2023",
    championship: "Départemental",
    category: "Seniors",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 2",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82370647?division=119132&phase=190366&poule=440810",
        players: [
          {
            playerName: "BEAUDEY Laurie",
            email: "beaudey.laurie@gmail.com",
            tel: "06.62.18.57.09",
            ranking: "15/3",
            doubleRanking: "9",
            licenceNum: "0610597 S",
          },
          {
            playerName: "PACCAUD lucie",
            email: "lucie-01@live.fr",
            tel: "06.10.61.24.80",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "4020204 L",
          },
          {
            playerName: "LAURENT Andrea",
            email: "andrealaurent202@gmail.com",
            tel: "06.66.08.01.62",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "9212356 E",
          },
          {
            playerName: "ALBAN Eléna",
            email: "alban.ceciliaetstephane@neuf.fr",
            tel: "06.35.25.88.90",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "6162636 S",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06.59.77.38.69",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7966067 T",
          },
          {
            playerName: "CATHERIN Charlotte",
            email: "charlotte.catherin@gmail.com",
            tel: "06.31.39.71.42",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "8312679 V",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 3",
        group: "F",
        path: "https://tenup.fft.fr/championnat/82370647?division=119131&phase=190365&poule=440819",
        players: [
          {
            playerName: "CATHERIN Charlotte",
            email: "charlotte.catherin@gmail.com",
            tel: "06.31.39.71.42",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "8312679 V",
          },
          {
            playerName: "DEFALLETANS Clotilde",
            email: "agnes.defalletans@gmail.com",
            tel: "06.11.65.97.15",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2790780 F",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06.43.84.05.43",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7263130 F",
          },
          {
            playerName: "GRANGER Noémie",
            email: "vergranger@orange.fr",
            tel: "06.25.70.61.32",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4540484 H",
          },
          {
            playerName: "PONCET Florence",
            email: "fd.poncet@orange.fr",
            tel: "06.72.82.36.27",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4108295 M",
          },
          {
            playerName: "BOURDON Marie-Laure",
            email: "mlbourdon01@gmail.com",
            tel: "06.10.07.96.79",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1022364 P",
          },
          {
            playerName: "GRANGER Véronique",
            email: "vergranger@orange.fr",
            tel: "06.25.70.61.32",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0594192 K",
          },
          {
            playerName: "GUERIN Christine",
            email: "christine.guerin1011@orange.fr",
            tel: "06.79.98.49.19",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1187689 R",
          },
          {
            playerName: "FARAONE Shauna",
            email: "shaunaf@hotmail.fr",
            tel: "06.59.52.03.88",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "7638012 L",
          },
          {
            playerName: "DIETRICH AURORE",
            email: "aurorechandon@outlook.fr",
            tel: "06.41.95.08.14",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "2121271 D",
          },
        ],
      },
    ],
  },
  {
    competitionId: 8,
    season: "2023",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 2",
        group: "T",
        path: "https://tenup.fft.fr/championnat/82336005?division=115087&phase=183775&poule=424659",
        players: [
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06.59.77.38.69",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7966067 T",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06.43.84.05.43",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7263130 F",
          },
          {
            playerName: "PONCET Florence",
            email: "fd.poncet@orange.fr",
            tel: "06.72.82.36.27",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4108295 M",
          },
          {
            playerName: "GUERIN Christine",
            email: "christine.guerin1011@orange.fr",
            tel: "06.79.98.49.19",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1187689 R",
          },
          {
            playerName: "ZAGHDOUD Iman",
            email: "imane.j83@gmail.com",
            tel: "06.28.78.20.68",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "0717414 X",
          },
          {
            playerName: "GRANGER Véronique",
            email: "vergranger@orange.fr",
            tel: "06.25.70.61.32",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0594192 K",
          },
        ],
      },
    ],
  },
  {
    competitionId: 9,
    season: "2023",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Division 3",
        group: "F",
        path: "https://tenup.fft.fr/championnat/82336006?division=114639&phase=183145&poule=425130",
        players: [
          {
            playerName: "CEDDIA Michel",
            email: "ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "PENIN Gonzague",
            email: "penin.gonzague@outlook.com",
            tel: "06.71.32.31.85",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "1047404 G",
          },
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BRUNET Nicolas",
            email: "nbrunet40@neuf.fr",
            tel: "06.86.33.70.22",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1338296 U",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "clairbenjamin71@gmail.com",
            tel: "06.43.93.15.99",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1990929 C",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5564257 E",
          },
        ],
      },
    ],
  },
  {
    competitionId: 10,
    season: "2024",
    championship: "Ligue",
    category: "Seniors 55+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Interdépartemantale 1",
        group: "K",
        path: "https://tenup.fft.fr/championnat/82397561?division=121504&phase=196714&poule=446381",
        players: [
          {
            playerName: "CEDDIA Michel",
            email: " ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7628206 C",
          },
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 0",
          },
          {
            playerName: "BRUNET Nicolas",
            email: "nbrunet40@neuf.fr",
            tel: "06.86.33.70.22",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1338296 U",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5564257 E",
          },
        ],
      },
    ],
  },
  {
    competitionId: 11,
    season: "2024",
    championship: "Ligue",
    category: "Seniors 35+",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Interdépartemantale 2",
        group: "O",
        path: "https://tenup.fft.fr/championnat/82363721?division=122551&phase=196306&poule=446495",
        players: [
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06.59.77.38.69",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7966067 T",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06.43.84.05.43",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7263130 F",
          },
          {
            playerName: "PONCET Florence",
            email: "fd.poncet@orange.fr",
            tel: "06.72.82.36.27",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "4108295 M",
          },
          {
            playerName: "DIETRICH Aurore",
            email: "aurorechandon@outlook.fr",
            tel: "06.41.95.08.14",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2121271 D",
          },
        ],
      },
    ],
  },
  {
    competitionId: 12,
    season: "2024",
    championship: "Départemental",
    category: "11/12 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 2",
        group: "D",
        path: "https://tenup.fft.fr/championnat/82410345?division=123393&phase=197419&poule=448214",
        players: [
          {
            playerName: "GREHAL Leon",
            email: "maxime.grehal@gmail.com",
            tel: "06.70.53.67.90",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1022435 S",
          },
          {
            playerName: "GRIVEAU Julliann",
            email: "seixolaurie@hotmail.fr",
            tel: "06.50.55.41.97",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "3181723 U",
          },
          {
            playerName: "PALIJCZUK Milo",
            email: "lmaj.pali@gmail.com",
            tel: "06 83 82 26 97",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1314822 D",
          },
          {
            playerName: "MITANCHEZ Gabin",
            email: "clau71@hotmail.fr",
            tel: "06.84.17.04.39",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "0598540 L",
          },
        ],
      },
    ],
  },
  {
    competitionId: 13,
    season: "2024",
    championship: "Départemental",
    category: "13/14 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82410347?division=123396&phase=197422&poule=448136",
        players: [
          {
            playerName: "SALGADO Rafael",
            email: "gmarechal01@gmail.com",
            tel: "06.43.84.05.43",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4546267 U",
          },
          {
            playerName: "PANIE César",
            email: "jeromepanie@gmail.com",
            tel: "06.88.32.78.49",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "4544557 K",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 2",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82410347?division=123395&phase=197421&poule=448219",
        players: [
          {
            playerName: "LAY Aslan",
            email: "lay.stephane@wanadoo.fr",
            tel: "06.13.63.87.01",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1047355 D",
          },
          {
            playerName: "GUILLEMIN Aloïs",
            email: "guillemin.guillaume@orange.fr",
            tel: "06.59.27.42.02",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "0595594 J",
          },
          {
            playerName: "ALBAN Quentin",
            email: "alban.ceciliaetstephane@neuf.fr",
            tel: "06.73.24.76.98",
            ranking: "40",
            rankingDouble: "18",
            licenceNum: "8022720 X",
          },
          {
            playerName: "PENIN Louis",
            email: "penin.gonzague@outlook.com",
            tel: "06.71.32.31.85",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1033065 W",
          },
        ],
      },
    ],
  },
  {
    competitionId: 14,
    season: "2024",
    championship: "Départemental",
    category: "15/18 ans",
    gender: "Filles",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82410348?division=123658&phase=197790&poule=448771",
        players: [
          {
            playerName: "ALBAN Eléna",
            email: "alban.ceciliaetstephane@neuf.fr",
            tel: "06.35.25.88.90",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "6162636 S",
          },
          {
            playerName: "GRANGER Noémie",
            email: "vergranger@orange.fr",
            tel: "06.25.70.61.32",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4540484 H",
          },
        ],
      },
    ],
  },
  {
    competitionId: 15,
    season: "2024",
    championship: "Départemental",
    category: "15/18 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 2",
        group: "I",
        path: "https://tenup.fft.fr/championnat/82410349?division=123656&phase=197785&poule=448763",
        players: [
          {
            playerName: "SURACE Adrien",
            email: "sandrine.surace@sfr.fr",
            tel: "06.43.70.43.56",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1634354 W",
          },
          {
            playerName: "DEMIRAY Kenan",
            email: "kupraa@gmail.com",
            tel: "06.69.13.07.90",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "4440129 B",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 3",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82410349?division=123657&phase=197786&poule=448764",
        players: [
          {
            playerName: "CHASSANDE-PATRON Louis",
            email: "dasmure@yahoo.fr",
            tel: "06 44 74 47 33",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0598539 K",
          },
          {
            playerName: "BERANGER Corentin",
            email: "guillaume.myriam@hotmail.fr",
            tel: "06.84.08.21.12",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0595576 P",
          },
          {
            playerName: "MARTIN Charlie",
            email: "juliemichelfr@gmail.com",
            tel: "06.74.05.87.74",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1990991 V",
          },
        ],
      },
    ],
  },
  {
    competitionId: 16,
    season: "2024",
    championship: "Coupe Des Dames",
    category: "Seniors",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "",
        path: "https://tenup.fft.fr/championnat/82407080?division=122877&phase=196738",
        players: [
          {
            playerName: "DIETRICH AURORE",
            email: "aurorechandon@outlook.fr",
            tel: "06.41.95.08.14",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2121271 D",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06.75.09.61.11",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2527820 E",
          },
          {
            playerName: "AMORIM Cindy",
            email: "cindy.amorim71@gmail.com",
            tel: "06.32.95.81.71",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "0615498 U",
          },
          {
            playerName: "REYDET Céline",
            email: "celine.dupui@gamil.com",
            tel: "06.32.50.32.55",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1639152 L",
          },
          {
            playerName: "VULIN Marion",
            email: "marion.vulin@gmail.com",
            tel: "06.21.70.27.94",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "2528205 Y",
          },
          {
            playerName: "MATHIAS Axelle",
            email: "axellemathias@gmail.com",
            tel: "06.89.46.72.81",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1752090 V",
          },
        ],
      },
    ],
  },
  {
    competitionId: 27,
    season: "2024",
    championship: "Départemental",
    category: "Seniors",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82440946?division=126341&phase=202647&poule=461998",
        players: [
          {
            playerName: "PERRIN lucie (C)",
            email: "-",
            tel: "06 10 61 24 80",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "4020204 L",
          },
          {
            playerName: "BEAUDEY Laurie",
            email: "-",
            tel: "06.62.18.57.09",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "0610597 S",
          },
          {
            playerName: "ALBAN Eléna",
            email: "-",
            tel: "06 35 25 88 90",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "6162636 S",
          },
          {
            playerName: "LAURENT Andrea",
            email: "-",
            tel: "06.66.08.01.62",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "9212356 E",
          },
          {
            playerName: "CATHERIN Charlotte",
            email: "-",
            tel: "06 31 39 71 42",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "8312679 V",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06 59 77 38 69",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7966067 T",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 3",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82440946?division=126343",
        players: [
          {
            playerName: "CATHERIN Charlotte (C)",
            email: "-",
            tel: "06 31 39 71 42",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "8312679 V",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06 59 77 38 69",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7966067 T",
          },
          {
            playerName: "DEFALLETANS Clotilde",
            email: "-",
            tel: "07 82 69 46 32",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2790780 F",
          },
          {
            playerName: "PONCET Florence",
            email: "-",
            tel: "06.72.82.36.27",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "4108295 M",
          },
          {
            playerName: "DIETRICH AURORE (C)",
            email: "aurorechandon@outlook.fr",
            tel: "06 41 95 08 14",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2121271 D",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7263130 F",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2527820 E",
          },
        ],
      },
    ],
  },
  {
    competitionId: 28,
    season: "2024",
    championship: "Départemental",
    category: "Seniors",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82440947?division=126337&phase=202643&poule=462993",
        players: [
          {
            playerName: "DU ROURE Ludovic",
            email: "-",
            tel: "06.73.04.93.20",
            ranking: "15/2",
            doubleRanking: "8",
            licenceNum: "2317909 R",
          },
          {
            playerName: "BRESSAN Loic",
            email: "-",
            tel: "06.50.78.05.81",
            ranking: "15/3",
            doubleRanking: "9",
            licenceNum: "2205855 T",
          },
          {
            playerName: "SCHULLER Antoine",
            email: "-",
            tel: "06.10.34.28.46",
            ranking: "15/3",
            doubleRanking: "9",
            licenceNum: "6348702 M",
          },
          {
            playerName: "GAUVRIT Frédéric (C)",
            email: "-",
            tel: "06.60.61.21.53",
            ranking: "15/3",
            doubleRanking: "9",
            licenceNum: "4060421 A",
          },
          {
            playerName: "PERRIN Thomas",
            email: "-",
            tel: "06.37.30.60.91",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "4924761 A",
          },
          {
            playerName: "SINIBALDI Thomas",
            email: "-",
            tel: "06.58.91.15.06",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "3025132 L",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 2",
        group: "E",
        path: "https://tenup.fft.fr/championnat/82440947?division=126338&phase=202644&poule=463000",
        players: [
          {
            playerName: "PERRIN Thomas (C)",
            email: "-",
            tel: "06.37.30.60.91",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "4924761 A",
          },
          {
            playerName: "SINIBALDI Thomas",
            email: "-",
            tel: "06.58.91.15.06",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "3025132 L",
          },
          {
            playerName: "MATRAS Mathieu",
            email: "-",
            tel: "06.07.43.71.15",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "7486886 U",
          },
          {
            playerName: "PENIN Gonzague",
            email: "-",
            tel: "06.71.32.31.85",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "1047404 G",
          },
          {
            playerName: "CEDDIA Michel",
            email: "-",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "MARTIN Alexandre",
            email: "-",
            tel: "06.29.51.49.28",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2317754 X (2024)",
          },
          {
            playerName: "MEYER Yan",
            email: "-",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BROISE Gérard",
            email: "-",
            tel: "06.61.41.55.88",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5564257 E",
          },
          {
            playerName: "BRUNET Nicolas",
            email: "-",
            tel: "06.86.33.70.22",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1338296 U",
          },
          {
            playerName: "MAZILLE Ludovic",
            email: "-",
            tel: "06.63.39.00.20",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5103391 N",
          },
        ],
      },
      {
        teamNum: 3,
        level: "Division 4",
        group: "D",
        path: "https://tenup.fft.fr/championnat/82440947?division=126340&phase=202646&poule=463025",
        players: [
          {
            playerName: "CEDDIA Michel",
            email: "-",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "MARTIN Alexandre",
            email: "-",
            tel: "06.29.51.49.28",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2317754 X (2024)",
          },
          {
            playerName: "MEYER Yan",
            email: "-",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BROISE Gérard",
            email: "-",
            tel: "06.61.41.55.88",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5564257 E",
          },
          {
            playerName: "BRUNET Nicolas",
            email: "-",
            tel: "06.86.33.70.22",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1338296 U",
          },
          {
            playerName: "MAZILLE Ludovic",
            email: "-",
            tel: "06.63.39.00.20",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5103391 N",
          },
          {
            playerName: "LETOURNEAUX Quentin",
            email: "-",
            tel: "07.88.19.05.42",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "4627072 A",
          },
          {
            playerName: "GATINET Francois Xavier",
            email: "-",
            tel: "06.60.85.07.50",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1071895 C",
          },
          {
            playerName: "SURACE Adrien",
            email: "-",
            tel: "07.86.77.27.94",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1634354 W",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "-",
            tel: "06.43.93.15.99",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224240 H",
          },
        ],
      },
      {
        teamNum: 4,
        level: "Division 5",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82440947?division=126383&phase=202695&poule=463029",
        players: [
          {
            playerName: "BRUNET Nicolas",
            email: "-",
            tel: "06.86.33.70.22",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1338296 U",
          },
          {
            playerName: "MAZILLE Ludovic",
            email: "-",
            tel: "06.63.39.00.20",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5103391 N",
          },
          {
            playerName: "LETOURNEAUX Quentin",
            email: "-",
            tel: "07.88.19.05.42",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "4627072 A",
          },
          {
            playerName: "GATINET Francois Xavier",
            email: "-",
            tel: "06.60.85.07.50",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1071895 C",
          },
          {
            playerName: "SURACE Adrien",
            email: "-",
            tel: "07.86.77.27.94",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1634354 W",
          },
          {
            playerName: "PANIE Victor",
            email: "-",
            tel: "06.38.77.99.01",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "8356032 T",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "-",
            tel: "06.43.93.15.99",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224240 H",
          },
          {
            playerName: "CATHERIN Jérémie (C)",
            email: "-",
            tel: "06.21.78.60.43",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "8312714 H",
          },
          {
            playerName: "MARCHAND Frédéric",
            email: "-",
            tel: "06.45.16.05.56",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1033027 E",
          },
          {
            playerName: "MEYER Yan (C)",
            email: "-",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BORNUAT Charly",
            email: "-",
            tel: "07.68.17.88.45",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2527517 A",
          },
        ],
      },
    ],
  },
  {
    competitionId: 17,
    season: "2025",
    championship: "Départemental",
    category: "11/12 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 2",
        group: "C",
        path: "https://tenup.fft.fr/championnat/82490643?division=130942&phase=210097&poule=471538",
        players: [
          {
            playerName: "PALIJCZUK Milo",
            email: "lmaj.pali@gmail.com",
            tel: "06 83 82 26 97",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1314822 D",
          },
          {
            playerName: "LESBRE Maël",
            email: "elodos@hotmail.fr",
            tel: "06 42 93 06 93",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1357142 D",
          },
          {
            playerName: "MITANCHEZ Gabin",
            email: "clau71@hotmail.fr",
            tel: "06 84 17 04 39",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0598540 L",
          },
          {
            playerName: "ARBELLOT-REPAIRE Tom",
            email: "zazalice@hotmail.com",
            tel: "06 16 91 50 32",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1447809 E",
          },

          {
            playerName: "GRIVEAU Julliann",
            email: "seixolaurie@hotmail.fr",
            tel: "06.50.55.41.97",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "3181723 U",
          },
        ],
      },
    ],
  },
  {
    competitionId: 18,
    season: "2025",
    championship: "Départemental",
    category: "13/14 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82490647?division=131013&phase=210189&poule=471332",
        players: [
          {
            playerName: "PANIE César",
            email: "jeromepanie@gmail.com",
            tel: "06 88 32 78 49",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "4544557 K",
          },
          {
            playerName: "SALGADO Rafael",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "4546267 U",
          },
          {
            playerName: "GREHAL Leon",
            email: "maxime.grehal@gmail.com",
            tel: "06.70.53.67.90",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1022435 S",
          },
          {
            playerName: "GUILLEMIN Aloïs",
            email: "guillemin.guillaume@orange.fr",
            tel: "06 59 27 42 02",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0595594 J",
          },
        ],
      },
    ],
  },
  {
    competitionId: 19,
    season: "2025",
    championship: "Départemental",
    category: "11/14 ans",
    gender: "Filles",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82490653",
        players: [
          {
            playerName: "AUPOIL Lise",
            email: "vaupoil@aol.com",
            tel: "06 75 12 07 35",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "9888851 A",
          },
          {
            playerName: "PEREZ LOPEZ Ana",
            email: "luciedaud@hotmail.com",
            tel: "06 06 98 85 55",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1135594 R",
          },
          {
            playerName: "MARTINEZ Shany",
            email: "lisa3004@hotmail.fr",
            tel: "06 70 49 95 84",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "4411597 N",
          },
        ],
      },
    ],
  },
  {
    competitionId: 20,
    season: "2025",
    championship: "Départemental",
    category: "15/18 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division 3",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82490662?division=131135&phase=210342&poule=471552",
        players: [
          {
            playerName: "SURACE Adrien",
            email: "sandrine.surace@sfr.fr",
            tel: "06 43 70 43 56",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1634354 W",
          },
          {
            playerName: "ROHART Vincent",
            email: "rohartsb@gmail.com",
            tel: "07 84 66 90 14",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2408016 H",
          },
          {
            playerName: "BONNABAUD Mathis",
            email: "mathis.bonnabaud@gmail.com",
            tel: "07 84 66 90 14",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1105693 P",
          },
          {
            playerName: "MARTINEZ Mathys",
            email: "lisa3004@hotmail.fr",
            tel: "06 70 49 95 84",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "2917110 W",
          },
          {
            playerName: "GUERBER Bastien",
            email: "olivier.karinette@gmail.com",
            tel: "06 63 51 96 42",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "2667917 J",
          },
          {
            playerName: "RIGOLLET Julien",
            email: "ludovic.rigollet@orange.fr",
            tel: "06 83 03 38 04",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "2667925 T",
          },
        ],
      },
    ],
  },
  {
    competitionId: 21,
    season: "2025",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Division 2",
        group: "5",
        path: "https://tenup.fft.fr/championnat/82472529?division=128658&phase=206976&poule=468234",
        players: [
          {
            playerName: "PACCOUD Yann",
            email: "yann.paccoud@gmail.com",
            tel: "07 77 31 68 46",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0645144 T",
          },
          {
            playerName: "GATINET Francois Xavier",
            email: "fxparisien71@hotmail.fr",
            tel: "06 60 85 07 50",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1071895 C",
          },
          {
            playerName: "THIVENT Mathieu",
            email: "mathieuthivent@gmail.com",
            tel: "06 33 59 78 55",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3256993 J",
          },
          {
            playerName: "MARCHAND Frédéric",
            email: "fredericmarchand01@gmail.com",
            tel: "06 45 16 05 56",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1033027 E",
          },
          {
            playerName: "BROYER Alexis",
            email: "alexisbroyer@gmail.com",
            tel: "06 85 28 75 70",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224220 L",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "clairbenjamin71@gmail.com",
            tel: "06 43 93 15 99",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1990929 C",
          },
          {
            playerName: "PETIT Hervé",
            email: "kekevalpetit@aol.com",
            tel: "06 11 03 15 18",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "0619205 Y",
          },
          {
            playerName: "CHASSANDE-PATRON Olivier",
            email: "dasmure@yahoo.fr",
            tel: "06 44 74 47 33",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "0793292 Y",
          },
          {
            playerName: "LECLERCQ Stéphane",
            email: "leclercqs25@gmail.com",
            tel: "06 08 73 25 16",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "5638808 N",
          },
          {
            playerName: "MONAVON Simon",
            email: "simon.monavon@gmail.com",
            tel: "06 81 90 74 97",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "3224266 L",
          },
        ],
      },
    ],
  },
  {
    competitionId: 22,
    season: "2025",
    championship: "Interdépartemental",
    category: "Seniors 55+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Interdépartemantale 1",
        group: "8",
        path: "https://tenup.fft.fr/championnat/82472533?division=128667&phase=207007&poule=468040",
        players: [
          {
            playerName: "CEDDIA Michel",
            email: " ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 0",
          },
          {
            playerName: "SASSOT Jean-Pierre",
            email: "jean-pierre.sassot@wanadoo.fr",
            tel: "06 77 38 44 64",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5809130 W",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5564257 E",
          },
        ],
      },
    ],
  },
  {
    competitionId: 23,
    season: "2025",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Interdépartemantale 2",
        group: "21",
        path: "https://tenup.fft.fr/championnat/82472528?division=128653&phase=206955&poule=468196",
        players: [
          {
            playerName: "AMORIM Cindy",
            email: "cindy.amorim71@gmail.com",
            tel: "06 32 95 81 71",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0615498 U",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06 59 77 38 69",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7966067 T",
          },
          {
            playerName: "DIETRICH Aurore",
            email: "aurorechandon@outlook.fr",
            tel: "06 41 95 08 14",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2121271 D",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7263130 F",
          },
          {
            playerName: "MATHIAS Axelle",
            email: "axellemathias@gmail.com",
            tel: "06 89 46 72 81",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1752090 V",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2527820 E",
          },
        ],
      },
    ],
  },
  {
    competitionId: 24,
    season: "2025",
    championship: "Coupe Des Dames",
    category: "Seniors",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "",
        path: "https://tenup.fft.fr/championnat/82407080?division=122877&phase=196738",
        players: [
          {
            playerName: "PALIS Charline",
            email: "charline.palis45@orange.fr",
            tel: "07 81 69 33 26",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2791071 X",
          },
          {
            playerName: "DIETRICH AURORE",
            email: "aurorechandon@outlook.fr",
            tel: "06.41.95.08.14",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2121271 D",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06.75.09.61.11",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "2527820 E",
          },
          {
            playerName: "MATHIAS Axelle",
            email: "axellemathias@gmail.com",
            tel: "06 89 46 72 81",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1752090 V",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7263130 F",
          },
          {
            playerName: "REYDET Céline",
            email: "celine.dupui@gamil.com",
            tel: "06 32 50 32 55",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1639152 L",
          },
          {
            playerName: "BERLAND Fanny",
            email: "fan_berland@hotmail.com",
            tel: "06 59 47 20 60",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "9277941 T",
          },
        ],
      },
    ],
  },
  {
    competitionId: 25,
    season: "2025",
    championship: "Départemental",
    category: "Seniors",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "B",
        path: "https://tenup.fft.fr/championnat/82524057?division=133524&phase=214514&poule=482559",
        players: [
          {
            playerName: "PERRIN lucie (C)",
            email: "-",
            tel: "06 10 61 24 80",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "4020204 L",
          },
          {
            playerName: "BESSON Morgane",
            email: "-",
            tel: "06 67 42 75 36",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "2443835 S",
          },
          {
            playerName: "DEFALLETANS Clotilde",
            email: "-",
            tel: "07 82 69 46 32",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "2790780 F",
          },
          {
            playerName: "ALBAN Eléna",
            email: "-",
            tel: "06 35 25 88 90",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "6162636 S",
          },
          {
            playerName: "CATHERIN Charlotte",
            email: "-",
            tel: "06 31 39 71 42",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "8312679 V",
          },
          {
            playerName: "AMORIM Cindy",
            email: "-",
            tel: "06 32 95 81 71",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0615498 U",
          },
          {
            playerName: "PALIS Charline",
            email: "charline.palis45@orange.fr",
            tel: "07 81 69 33 26",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2791071 X",
          },
          {
            playerName: "DIETRICH AURORE",
            email: "aurorechandon@outlook.fr",
            tel: "06 41 95 08 14",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2121271 D",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2527820 E",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06 59 77 38 69",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7966067 T",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 3",
        group: "G",
        path: "https://tenup.fft.fr/championnat/82524057?division=133522&phase=214512&poule=482595",
        players: [
          {
            playerName: "CATHERIN Charlotte",
            email: "-",
            tel: "06 31 39 71 42",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "8312679 V",
          },
          {
            playerName: "AMORIM Cindy",
            email: "-",
            tel: "06 32 95 81 71",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0615498 U",
          },
          {
            playerName: "PALIS Charline",
            email: "charline.palis45@orange.fr",
            tel: "07 81 69 33 26",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2791071 X",
          },
          {
            playerName: "DIETRICH AURORE (C)",
            email: "aurorechandon@outlook.fr",
            tel: "06 41 95 08 14",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2121271 D",
          },
          {
            playerName: "GRANGER Noémie",
            email: "-",
            tel: "06 25 70 61 32",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "4540484 H",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2527820 E",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06 59 77 38 69",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7966067 T",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7263130 F",
          },
          {
            playerName: "MATHIAS Axelle",
            email: "axellemathias@gmail.com",
            tel: "06 89 46 72 81",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1752090 V",
          },
          {
            playerName: "NEYRAND Marion",
            email: "-",
            tel: "06 59 24 91 60",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224270 R",
          },
        ],
      },
    ],
  },
  {
    competitionId: 26,
    season: "2025",
    championship: "Départemental",
    category: "Seniors",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "D",
        path: "https://tenup.fft.fr/championnat/82524058?division=133529&phase=214519&poule=484272",
        players: [
          {
            playerName: "BRESSAN Loic",
            email: "-",
            tel: "06.50.78.05.81",
            ranking: "15/2",
            doubleRanking: "8",
            licenceNum: "2205855 T",
          },
          {
            playerName: "DU ROURE Ludovic",
            email: "-",
            tel: "06.73.04.93.20",
            ranking: "15/2",
            doubleRanking: "8",
            licenceNum: "2317909 R",
          },
          {
            playerName: "SCHULLER Antoine",
            email: "-",
            tel: "06.10.34.28.46",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "6348702 M",
          },
          {
            playerName: "GAUVRIT Frédéric (C)",
            email: "-",
            tel: "06.60.61.21.53",
            ranking: "15/4",
            doubleRanking: "10",
            licenceNum: "4060421 A",
          },
          {
            playerName: "SINIBALDI Thomas",
            email: "-",
            tel: "06.58.91.15.06",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "3025132 L",
          },
          {
            playerName: "PENIN Gonzague",
            email: "-",
            tel: "06.71.32.31.85",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "1047404 G",
          },
          {
            playerName: "LAMORT Charles-Etienne",
            email: "-",
            tel: "06.85.17.42.60",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "1836842 S",
          },
          {
            playerName: "MIQUEL Anthony",
            email: "-",
            tel: "06.89.70.21.41",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "8448238 S",
          },
          {
            playerName: "MEJAT Jérémy",
            email: "-",
            tel: "07.53.24.96.37",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "3224240 H",
          },
          {
            playerName: "BARDET Marceau",
            email: "-",
            tel: "06.26.43.69.64",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7052287 D",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division 2",
        group: "E",
        path: "https://tenup.fft.fr/championnat/82524058?division=133528&phase=214518&poule=484287",
        players: [
          {
            playerName: "SINIBALDI Thomas",
            email: "-",
            tel: "06.58.91.15.06",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "3025132 L",
          },
          {
            playerName: "PENIN Gonzague",
            email: "-",
            tel: "06.71.32.31.85",
            ranking: "15/5",
            doubleRanking: "11",
            licenceNum: "1047404 G",
          },
          {
            playerName: "LAMORT Charles-Etienne (C)",
            email: "-",
            tel: "06.85.17.42.60",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "1836842 S",
          },
          {
            playerName: "MIQUEL Anthony",
            email: "-",
            tel: "06.89.70.21.41",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "8448238 S",
          },
          {
            playerName: "MEJAT Jérémy",
            email: "-",
            tel: "07.53.24.96.37",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "3224240 H",
          },
          {
            playerName: "BARDET Marceau",
            email: "-",
            tel: "06.26.43.69.64",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7052287 D",
          },
          {
            playerName: "SURACE Adrien",
            email: "-",
            tel: "07.86.77.27.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1634354 W",
          },
          {
            playerName: "CEDDIA Michel",
            email: "-",
            tel: "06.82.94.80.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7628206 C",
          },
          {
            playerName: "SASSOT Jean-Pierre",
            email: "-",
            tel: "06.77.38.44.64",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5809130 W",
          },
          {
            playerName: "PACCOUD Yann",
            email: "-",
            tel: "07.77.31.68.46",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0645144 T",
          },
        ],
      },
      {
        teamNum: 3,
        level: "Division 4",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82524058?division=133526&phase=214516&poule=484321",
        players: [
          {
            playerName: "MEJAT Jérémy",
            email: "-",
            tel: "07.53.24.96.37",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "3224240 H",
          },
          {
            playerName: "BARDET Marceau",
            email: "-",
            tel: "06.26.43.69.64",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7052287 D",
          },
          {
            playerName: "SURACE Adrien",
            email: "-",
            tel: "07.86.77.27.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1634354 W",
          },
          {
            playerName: "SASSOT Jean-Pierre",
            email: "-",
            tel: "06.77.38.44.64",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5809130 W",
          },
          {
            playerName: "CEDDIA Michel (C)",
            email: "-",
            tel: "06.82.94.80.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7628206 C",
          },
          {
            playerName: "PACCOUD Yann",
            email: "-",
            tel: "07.77.31.68.46",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0645144 T",
          },
          {
            playerName: "MEYER Yan",
            email: "-",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BROISE Gérard",
            email: "-",
            tel: "06.61.41.55.88",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5564257 E",
          },
          {
            playerName: "MARCHAND Frédéric",
            email: "-",
            tel: "06.45.16.05.56",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1033027 E",
          },
          {
            playerName: "THIVENT Mathieu",
            email: "-",
            tel: "06.33.59.78.55",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "3256993 J",
          },
        ],
      },
      {
        teamNum: 4,
        level: "Division 5",
        group: "D",
        path: "https://tenup.fft.fr/championnat/82524058?division=133525&phase=214515&poule=484345",
        players: [
          {
            playerName: "CEDDIA Michel",
            email: "-",
            tel: "06.82.94.80.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7628206 C",
          },
          {
            playerName: "PACCOUD Yann",
            email: "-",
            tel: "07.77.31.68.46",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0645144 T",
          },
          {
            playerName: "MEYER Yan (C)",
            email: "-",
            tel: "06.68.76.00.63",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7303664 P",
          },
          {
            playerName: "BROISE Gérard",
            email: "-",
            tel: "06.61.41.55.88",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5564257 E",
          },
          {
            playerName: "MARCHAND Frédéric",
            email: "-",
            tel: "06.45.16.05.56",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1033027 E",
          },
          {
            playerName: "THIVENT Mathieu",
            email: "-",
            tel: "06.33.59.78.55",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "3256993 J",
          },
          {
            playerName: "CLAIR Benjamin",
            email: "-",
            tel: "06.43.93.15.99",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224240 H",
          },
          {
            playerName: "BROYER Alexis",
            email: "-",
            tel: "06.85.28.75.70",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7052287 D",
          },
          {
            playerName: "PETIT Hervé",
            email: "-",
            tel: "06.11.03.15.18",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1634354 W",
          },
          {
            playerName: "DESHENRY Arnaud",
            email: "-",
            tel: "06.77.53.37.22",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "5809130 W",
          },
        ],
      },
    ],
  },
  {
    competitionId: 27,
    season: "2026",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Division 2 Bis",
        group: "F",
        path: "https://tenup.fft.fr/championnat/82551233?division=137209&phase=220914&poule=489484",
        players: [
          // {
          //   playerName: "PACCOUD Yann",
          //   email: "yann.paccoud@gmail.com",
          //   tel: "07 77 31 68 46",
          //   ranking: "30/2",
          //   doubleRanking: "14",
          //   licenceNum: "0645144 T",
          // },
          {
            playerName: "CLAIR Benjamin",
            email: "clairbenjamin71@gmail.com",
            tel: "06 43 93 15 99",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1990929 C",
          },
          {
            playerName: "GATINET Francois Xavier (c)",
            email: "fxparisien71@hotmail.fr",
            tel: "06 60 85 07 50",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "1071895 C",
          },
          {
            playerName: "THIVENT Mathieu",
            email: "mathieuthivent@gmail.com",
            tel: "06 33 59 78 55",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "3256993 J",
          },
          // {
          //   playerName: "MARCHAND Frédéric",
          //   email: "fredericmarchand01@gmail.com",
          //   tel: "06 45 16 05 56",
          //   ranking: "30/4",
          //   doubleRanking: "16",
          //   licenceNum: "1033027 E",
          // },
          {
            playerName: "MONAVON Simon",
            email: "simon.monavon@gmail.com",
            tel: "06 81 90 74 97",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224266 L",
          },
          {
            playerName: "BROYER Alexis",
            email: "alexisbroyer@gmail.com",
            tel: "06 85 28 75 70",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "3224220 L",
          },
          // {
          //   playerName: "PETIT Hervé",
          //   email: "kekevalpetit@aol.com",
          //   tel: "06 11 03 15 18",
          //   ranking: "30/4",
          //   doubleRanking: "16",
          //   licenceNum: "0619205 Y",
          // },
          // {
          //   playerName: "CHASSANDE-PATRON Olivier",
          //   email: "dasmure@yahoo.fr",
          //   tel: "06 44 74 47 33",
          //   ranking: "30/5",
          //   doubleRanking: "17",
          //   licenceNum: "0793292 Y",
          // },
          // {
          //   playerName: "LECLERCQ Stéphane",
          //   email: "leclercqs25@gmail.com",
          //   tel: "06 08 73 25 16",
          //   ranking: "40",
          //   doubleRanking: "18",
          //   licenceNum: "5638808 N",
          // },
        ],
      },
    ],
  },
  {
    competitionId: 28,
    season: "2026",
    championship: "Interdépartemental",
    category: "Seniors 55+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Interdépartemantale 1",
        group: "A",
        path: "https://tenup.fft.fr/championnat/82551347?division=135959&phase=220796&poule=489225",
        players: [
          {
            playerName: "CEDDIA Michel (c)",
            email: " ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "7628206 C",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5564257 E",
          },
          {
            playerName: "SASSOT Jean-Pierre",
            email: "jean-pierre.sassot@wanadoo.fr",
            tel: "06 77 38 44 64",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "5809130 W",
          },
          {
            playerName: "MEYER Yan",
            email: "playti.meyer837101@free.fr",
            tel: "06.68.76.00.63",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7303664 0",
          },
        ],
      },
    ],
  },
  {
    competitionId: 29,
    season: "2026",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Interdépartemantale 2",
        group: "D",
        path: "https://tenup.fft.fr/championnat/82551232?division=135939&phase=220792&poule=489521",
        players: [
          {
            playerName: "BEAUDEY Laurie",
            email: "ceddia.laurie@gmail.com",
            tel: "06 32 95 81 71",
            ranking: "30",
            doubleRanking: "12",
            licenceNum: "610597 S",
          },
          {
            playerName: "DIETRICH Aurore",
            email: "aurorechandon@outlook.fr",
            tel: "06 41 95 08 14",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2121271 D",
          },
          {
            playerName: "CEDDIA Laurence",
            email: "laurenceceddia@aol.com",
            tel: "06 59 77 38 69",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "7966067 T",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2527820 E",
          },
          {
            playerName: "MATHIAS Axelle",
            email: "axellemathias@gmail.com",
            tel: "06 89 46 72 81",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1752090 V",
          },
          {
            playerName: "MARECHAL Gaëlle (c)",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7263130 F",
          },
          {
            playerName: "REYDET Céline",
            email: "celine.dupui@gmail.com",
            tel: "06 32 50 32 55",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1639152 L",
          },
          {
            playerName: "NEYRAND Marion",
            email: "marion.neyrand@gmail.com",
            tel: "06 59 24 91 60",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "3224270 R",
          },
        ],
      },
    ],
  },
  {
    competitionId: 30,
    season: "2026",
    championship: "Départemental",
    category: "11/12 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division X",
        group: "X",
        path: "https://tenup.fft.fr/championnat/82569088?division=",
        players: [
          {
            playerName: "GATINET Valentin",
            email: "fxparisien71@hotmail.fr",
            tel: "06 60 85 07 50",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1196299 Z",
          },
          {
            playerName: "GAFFIER Clément",
            email: "jef-cricri@club-internet.fr",
            tel: "06 12 29 66 61",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1911487 C",
          },
          {
            playerName: "ARBELLOT-REPAIRE Tom",
            email: "zazalice@hotmail.com",
            tel: "06 16 91 50 32",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1447809 E",
          },
        ],
      },
    ],
  },
  {
    competitionId: 31,
    season: "2026",
    championship: "Départemental",
    category: "13/14 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division X",
        group: "X",
        path: "https://tenup.fft.fr/championnat/82569090?division=",
        players: [
          {
            playerName: "LESBRE Maël",
            email: "elodos@hotmail.fr",
            tel: "06 42 93 06 93",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1357142 D",
          },
          {
            playerName: "GREHAL Leon",
            email: "maxime.grehal@gmail.com",
            tel: "06.70.53.67.90",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "1022435 S",
          },
          {
            playerName: "MITANCHEZ Gabin",
            email: "clau71@hotmail.fr",
            tel: "06 84 17 04 39",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0598540 L",
          },
        ],
      },
    ],
  },
  {
    competitionId: 32,
    season: "2026",
    championship: "Départemental",
    category: "15/18 ans",
    gender: "Garçons",
    teams: [
      {
        teamNum: 1,
        level: "Division X",
        group: "X",
        path: "https://tenup.fft.fr/championnat/82569093?division=",
        players: [
          {
            playerName: "PANIE César",
            email: "jeromepanie@gmail.com",
            tel: "06 88 32 78 49",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "4544557 K",
          },
          {
            playerName: "SALGADO Rafael",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "4546267 U",
          },
        ],
      },
      {
        teamNum: 2,
        level: "Division X",
        group: "X",
        path: "https://tenup.fft.fr/championnat/82569093?division=",
        players: [
          {
            playerName: "LAY Aslan",
            email: "lay.stephane@wanadoo.fr",
            tel: "06 13 63 87 01",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "1047355 D",
          },
          {
            playerName: "GUILLEMIN Aloïs",
            email: "guillemin.guillaume@orange.fr",
            tel: "06 59 27 42 02",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "0595594 J",
          },
          {
            playerName: "PUVILAND Clément",
            email: "puviland.sophie@gmail.com",
            tel: "06 07 94 32 75",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "1413583 C",
          },
        ],
      },
      {
        teamNum: 3,
        level: "Division X",
        group: "X",
        path: "https://tenup.fft.fr/championnat/82569093?division=",
        players: [
          {
            playerName: "BERANGER Corentin",
            email: "corentin-beranger@outlook.fr",
            tel: "06 84 08 21 12",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "0595576 P",
          },
          {
            playerName: "CHASSANDE-PATRON Louis",
            email: "dasmure@yahoo.fr",
            tel: "06 44 74 47 33",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "0598539 K",
          },
          {
            playerName: "FONTAINE Mathys",
            email: "m.doucet01@yahoo.com",
            tel: "06 40 17 78 76",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "4507983 F",
          },
          {
            playerName: "LAKRAA Ilyas",
            email: "pierremichel.guillermin@gmail.com-",
            tel: "07 67 85 26 82",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "3988130 Y",
          },
        ],
      },
    ],
  },
  {
    competitionId: 33,
    season: "2026",
    championship: "Coupe Des Dames",
    category: "Seniors",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "Division 1",
        group: "",
        path: "https://tenup.fft.fr/championnat/82572809?division=137707",
        players: [
          {
            playerName: "DI MAJO Stéphanie (c)",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "2527820 E",
          },
          {
            playerName: "AMORIM Cindy",
            email: "cindy.amorim71@gmail.com",
            tel: "06 32 95 81 71",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "0615498 U",
          },
          {
            playerName: "MARECHAL Gaëlle",
            email: "gmarechal01@gmail.com",
            tel: "06 43 84 05 43",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "7263130 F",
          },
          {
            playerName: "MATHIAS Axelle",
            email: "axellemathias@gmail.com",
            tel: "06 89 46 72 81",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "1752090 V",
          },
          {
            playerName: "DUCHATEAU Océane",
            email: "oceane.duchateau@gmail.com",
            tel: "06 51 85 68 27",
            ranking: "NC",
            doubleRanking: "19",
            licenceNum: "4539016 M",
          },
        ],
      },
    ],
  },
  {
    competitionId: 34,
    season: "2027",
    championship: "Interdépartementale",
    category: "Seniors 35+",
    gender: "Dames",
    teams: [
      {
        teamNum: 1,
        level: "GROUPE B",
        group: "E",
        path: "https://tenup.fft.fr/championnat/82662892?division=143417&phase=234532&poule=512008",
        players: [
          {
            playerName: "DIETRICH Aurore (c)",
            email: "aurorechandon@outlook.fr",
            tel: "06 41 95 08 14",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "2121271 D",
          },
          {
            playerName: "DI MAJO Stéphanie",
            email: "stephanie.dimajo@orange.fr",
            tel: "06 75 09 61 11",
            ranking: "30/2",
            doubleRanking: "15",
            licenceNum: "2527820 E",
          },
          {
            playerName: "LETELLIER DEJONGHE Céline",
            email: "cecile.dejonghe@gmail.com",
            tel: "06 98 28 86 59",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "8710230 R",
          },
          {
            playerName: "BERLAN Fanny",
            email: "fan_berland@hotmail.fr",
            tel: "06 59 47 20 60",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "9277941 T",
          },
          {
            playerName: "THIVENT Clémence",
            email: "catherin.ide@gmail.com",
            tel: "06 62 73 52 22",
            ranking: "40",
            doubleRanking: "18",
            licenceNum: "4508283 G",
          },
        ],
      },
    ],
  },
  {
    competitionId: 35,
    season: "2027",
    championship: "Interdépartemental",
    category: "Seniors 35+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "GROUPE C",
        group: "Z",
        path: "https://tenup.fft.fr/championnat/82662893?division=143426&phase=232600&poule=512196",
        players: [
          {
            playerName: "CLAIR Benjamin",
            email: "clairbenjamin71@gmail.com",
            tel: "06 43 93 15 99",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1990929 C",
          },
          {
            playerName: "GATINET Francois Xavier (c)",
            email: "fxparisien71@hotmail.fr",
            tel: "06 60 85 07 50",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "1071895 C",
          },
          {
            playerName: "GALLION Damien",
            email: "lodaetni@gmail.com",
            tel: "06 62 43 38 65",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "8583586 J",
          },
          {
            playerName: "PACCOUD Yann",
            email: "yann.paccoud@gmail.com",
            tel: "07 77 31 68 46",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "0645144 T",
          },
          {
            playerName: "THIVENT Mathieu",
            email: "mathieuthivent@gmail.com",
            tel: "06 33 59 78 55",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "3256993 J",
          },
          {
            playerName: "BROYER Alexis",
            email: "alexisbroyer@gmail.com",
            tel: "06 85 28 75 70",
            ranking: "30/4",
            doubleRanking: "16",
            licenceNum: "3224220 L",
          },
          {
            playerName: "LAY Stéphane",
            email: "lay.stephane@wanadoo.fr",
            tel: "06 13 63 87 01",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "4693922 N",
          },
          {
            playerName: "MONAVON Simon",
            email: "simon.monavon@gmail.com",
            tel: "06 81 90 74 97",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "3224266 L",
          },
        ],
      },
    ],
  },
  {
    competitionId: 36,
    season: "2027",
    championship: "Interdépartementale",
    category: "Seniors 55+",
    gender: "Messieurs",
    teams: [
      {
        teamNum: 1,
        level: "Phase Poules",
        group: "I",
        path: "https://tenup.fft.fr/championnat/82662897?division=143438&phase=232640&poule=511736",
        players: [
          {
            playerName: "SASSOT Jean-Pierre",
            email: "jean-pierre.sassot@wanadoo.fr",
            tel: "06 77 38 44 64",
            ranking: "30/1",
            doubleRanking: "13",
            licenceNum: "5809130 W",
          },
          {
            playerName: "CEDDIA Michel (c)",
            email: " ceddiam@aol.com",
            tel: "06.82.94.80.94",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "7628206 C",
          },
          {
            playerName: "BROISE Gérard",
            email: "inf.broise@wanadoo.fr",
            tel: "06.61.41.55.88",
            ranking: "30/2",
            doubleRanking: "14",
            licenceNum: "5564257 E",
          },
          {
            playerName: "LEROUX Franck",
            email: "laure.leroux@wanadoo.fr",
            tel: "06 63 85 06 24",
            ranking: "30/3",
            doubleRanking: "15",
            licenceNum: "3527797 L",
          },
          {
            playerName: "BOUSSIT Daniel",
            email: "daniel.boussit@orange.fr",
            tel: "06 78 69 27 04",
            ranking: "30/5",
            doubleRanking: "17",
            licenceNum: "3521553 Z",
          },
        ],
      },
    ],
  },
];

export default tableCompetitions;
